import React, {Component} from 'react';
import MainLayout from "../components/layouts/MainLayout";
import withAuth from "../hoc/withAuth";
import {Result} from "antd";

export interface UnderConstructProps {

}

export interface UnderConstructStates extends UnderConstructFields {
    processing: boolean;
}

export interface UnderConstructFields {
    adminName: string;
    companyCode: string;
}

class UnderConstruct extends Component<UnderConstructProps & any, UnderConstructStates> {
    constructor(props: UnderConstructProps & any) {
        super(props);
        this.state = {
            processing: false,
            companyCode: "",
            adminName: "",
        }
    }

    onDealerChange = async (data: any) => {
        console.log(data)
    }

    render() {
        return (
            <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Offer To Order`} defaultSelectedKeys={['m-offer-order']} defaultOpenKeys={['sm-offer']}>
            <Result
                status="404"
                title="Under Construct"
                subTitle="Maaf, Halaman / Modul / Section berikut masih dalam proses pembuatan."
            />
            </MainLayout>
        );
    }
}

export default withAuth(UnderConstruct,1);
